import { render } from "./MobilePayrollTable.vue?vue&type=template&id=770b0c9a"
import script from "./MobilePayrollTable.vue?vue&type=script&lang=js"
export * from "./MobilePayrollTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__